import PropTypes from 'prop-types';
import { Navigate, Outlet,useLocation } from 'react-router-dom';

import useAuth from '../hooks/useAuth';
// the component that helps us protect routes
const RequireAuth = ({ allowedRoles }) => {
    RequireAuth.propTypes = {
        allowedRoles: PropTypes.any,
    };
    const { auth } = useAuth();
    const location = useLocation();

    // const allowedRoles1 = Object.values(allowedRoles)
    // console.log("hello ROLE \t " + typeof (auth?.roles) + typeof (allowedRoles.values()));
    console.log('aida');
    console.log(allowedRoles);
    console.log(auth?.roles);

    // allowedRoles = JSON.parse(allowedRoles)

    // var authorized = false
    // Object.values(allowedRoles).forEach(role => {
    //     // console.log(role + "=== " + auth?.roles);
    //     // * check if the user is beyound the allowed roles
    //     if (role === auth?.roles)
    //         authorized = true
    // })

    // console.log(Object.values(allowedRoles).includes(auth?.roles));
    // console.log(typeof (allowedRoles1));
    // console.log("hello ROLE \t " + typeof (auth?.roles) + typeof (allowedRoles));
    // console.log("2nd test");
    // console.log(allowedRoles1?.include(auth?.roles));

    // console.log(auth?.roles?.find(role => allowedRoles?.includes(role)));
    return (
    // * simple without roles , just login
    // auth?.email ?
    // can protect all the child component
    // <Outlet />
    // replace the login in thier navigation history with the location that they came from
    // : <Navigate to="/login" state={{ from: location }} replace />
    //* support rule base permission [we check roles]
    // ! the good way is comparing the values of the two arrays,
    // !in case we have multiple roles assigned to one user , even it's not our case here
    // ?   auth?.roles?.find(role => allowedRoles?.includes(role))
    // auth?.roles == allowedRoles
    // authorized || false
        Object.values(allowedRoles).includes(auth?.roles) ? (
            <Outlet />
        ) : auth?.email ? (
            <Navigate
                to="/unauthorized"
                state={{ from: location }}
                replace
            />
        ) : (
            <Navigate
                to="/login"
                state={{ from: location }}
                replace
            />
        )
    );
};

export default RequireAuth;
